import Layout from "../Layouts/Index";
import {Link} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {Client} from "../Services/Prismic";
import {RichText} from "prismic-reactjs";
import {formatFullDate, isEmpty} from "../Assets/StaticContents/helpers";
import { useParams } from "react-router-dom";
import LoadingDiv from "../components/Loading";
import NoData from "../components/NoData";

const BlogView = () => {
    const [blog, setBlog] = useState({})
    const queryString = useParams();
    const [isLoading, setIsLoading] = React.useState(true)


    useEffect(() => {
        const fetchData = async () => {
            const response = await Client.getByID(queryString.id)

            if (response) {
                setBlog(response)
                setIsLoading(false)
            }
        }

        fetchData()
    }, [queryString])
    return (
        <Layout>
            <div className="px-2 sm:px-4 md:px-10 lg:px-16 py-4">
                <div className="xl:px-8 pb-4">
                    <Link to="/blogs" className="text-green-600 underline font-semibold py-4">
                        Go back to blogs
                    </Link>

                    {isLoading ? <LoadingDiv></LoadingDiv> :
                        <div>
                            {!isEmpty(blog) ?
                                <div>
                                    <div className="w-full my-4 mb-8">
                                        <img src={blog.data.image.url} loading="lazy" alt={blog.data.title}
                                             className="w-full h-auto object-cover object-top"/>
                                    </div>
                                    <div className="">
                                        {/*<p className="text-md font-medium text-gray-500">*/}
                                        {/*    Carpooling*/}
                                        {/*</p>*/}
                                        <div className="my-2">
                                            <div
                                                className="text-xl md:text-2xl font-semibold capitalize text-gray-700 py-1">
                                                {RichText.render(blog.data.title)}
                                            </div>
                                        </div>
                                        <p className="space-x-2 text-sm text-gray-500">
                                            <span>{formatFullDate(blog.first_publication_date)}</span>
                                        </p>
                                        <div className="my-4 sm-my-6 text-gray-600">
                                            {RichText.render(blog.data.body)}
                                        </div>
                                    </div>
                                </div>
                                :
                                <NoData text="No Blog Available" />
                            }
                        </div>
                    }
                </div>
            </div>
        </Layout>
    )
}

export default BlogView